// This file was automatically generated from passwordReset.html.
// Please don't edit this file by hand.

goog.provide('el8.template.multiuser_access.passwordReset');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.multiuser_access.signup');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.passwordReset.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FormBox el8BoxWithHeading el8FaxFlow mt15p"><form id="main-form"><img src="/static/images/e-circle-blue.png?v=20160729" style="width:40px;position:absolute;right:25px;top:20px;" /><h3 class="el8BrandColor el8LightWeight el8AlignCenter">Create a new password</h3><div class="el8LgSpacer"></div><h4 class="el8AlignCenter mbMd">Secure your account with a new password</h4><div class="el8LgSpacer"></div><div class="w80p el8FormHorizontal el8CenterBlock"><div class="el8FormGroup el8Row"><label class="el8Col4 el8StandardInputLabel">New password</label><div class="el8Col7"><input name="password1" type="password" class="el8StandardInput" placeholder=""></input></div><div class="el8Col1 el8Relative">');
  el8.template.multiuser_access.signup.passwordHelp(null, output);
  output.append('</div></div><div class="el8FormGroup el8Row"><label class="el8Col4 el8StandardInputLabel">Retype password</label><div class="el8Col7"><input name="password2" type="password" class="el8StandardInput" placeholder=""></input></div><div class="el8Col1 el8Relative">');
  el8.template.multiuser_access.signup.passwordMatch(null, output);
  output.append('</div></div><div class="el8SmSpacer"></div><div class="el8AlignCenter"><button id="go-to-chart" class="el8Btn el8BtnPrimary">Set new password and go to chart</button></div></div><div class="el8XLSpacer"></div></div></form></div>');
  if (!opt_sb) return output.toString();
};
